import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/splash",
    name: "Splash",
    meta: { layout: "blank-layout", requiresAuth: false },
    component: () => import(/* webpackChunkName: "splash-screen" */ "../views/SplashScreen.vue"),
  },
  {
    path: "/login",
    name: "Login",
    meta: { layout: "clean-layout", requiresAuth: false },
    component: () => import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/cashbalances",
    name: "CashBalances",
    meta: { layout: "cash-layout", requiresAuth: true },
    component: () => import(/* webpackChunkName: "cash-balances" */ "../views/CashBalances.vue"),
  },
  {
    path: "/payments",
    name: "Payments",
    meta: { layout: "cash-layout", requiresAuth: true },
    component: () => import(/* webpackChunkName: "payments" */ "../views/Payments.vue"),
  },
  {
    path: "/cashposition",
    name: "CashPosition",
    meta: { layout: "cash-layout", requiresAuth: true },
    component: () => import(/* webpackChunkName: "payments" */ "../views/CashPosition.vue"),
  },
  {
    path: "/accounttransactions/:account",
    name: "AccountTransactions",
    meta: { layout: "cash-layout", requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "account-transactions" */ "../views/AccountTransactions.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
